import { useApp } from "../helpers/app-context";
import { Sidebar } from "./Sidebar";
import { ReactComponent as MenuIcon } from "../assets/icons/menu.svg";
import { MobileSidebar } from "./MobileSidebar";
import { Logo } from "./Logo";
import { AskAutumnWidget } from "../pages/crm/AskAutumnWidget";

const MobileHeader = ({ onMenuClick }) => {
  return (
    <div className="h-[58px] fixed top-0 z-[9] left-0 w-full flex items-center justify-between px-5 shadow-[0px_4px_10px_0px_rgba(134,133,141,0.12)] bg-white border-b border-b-neutral-300">
      <div className="flex items-center gap-2.5">
        <button type="button" onClick={onMenuClick}>
          <MenuIcon />
        </button>
        <Logo className="!text-[25px] !leading-0 tracking-[-1.033px]" />
      </div>
      {/* <Notification /> */}
    </div>
  );
};

export function Page({ children }: { children: React.ReactNode }) {
  const {
    setSidebarExpanded,
    sidebarExpanded,
    isMobileSidebarOpen,
    setIsMobileSidebarOpen,
  } = useApp() as {
    isMobileSidebarOpen: boolean;
    setIsMobileSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setSidebarExpanded: React.Dispatch<React.SetStateAction<boolean>>;
    sidebarExpanded: boolean;
  };
  return (
    <div className="flex pt-[58px] lg:pt-0 w-full">
      <div className="lg:hidden">
        <MobileHeader onMenuClick={() => setIsMobileSidebarOpen((p) => !p)} />
      </div>
      <div className="hidden lg:block">
        <Sidebar
          sidebarExpanded={sidebarExpanded}
          setSidebarExpanded={setSidebarExpanded}
        />
      </div>
      {children}
      {/* Ask Autumn — mirrors autumn-frontend's chatbot pattern. Renders an
          inline flex column that shrinks the page content when open, and a
          fixed floating launcher when closed. State lives in app-context so
          state survives navigating between pages. */}
      <AskAutumnWidget />
      {isMobileSidebarOpen && <MobileSidebar />}
    </div>
  );
}
